export class ClassPayment{
    bookingId: number;
    command: {
        method: string;
        returnUrl: string;
    };
}


// WEBPACK FOOTER //
// ./src/holiday/models/ClassPayment.ts